<template>
  <!-- Main Box reporting and report Start -->
  <div>

  <stats></stats>

  <!-- report-page header start -->
  <div class="report-page-header">

    <!-- NEW close statistics start -->
    <div class="close-statistics" @click="exit()">×</div>
    <!-- NEW close statistics stop -->

    <form>

      <div class="rp-input-submit"><input type="submit" :value="$t('short')" disabled/></div>

      <!-- rp-form start -->
      <div class="rp-form-box">

        <div class="rp-form">

          <h3>{{$t('timepireod')}}</h3>

            <!-- ccr start -->
            <div class="ccr">

              <div class="ccr-1">
                <p>{{$t('from')}}</p>
                <div class="ccr-1-calendar">
                  <!-- || start calendar -->
                  <date-picker v-model="$store.state.startdate" valueType="format"></date-picker>
                  <!-- // stop calendar -->
                </div>
              </div>

              <div class="ccr-2 chasov">
                <div class="ccr-2-select">
                  <v-select :options="hours" :searchable="false" v-model="starttime.hour" style="background-color: white" class="selectpicker show-tick"></v-select>
                </div>
                <p>{{$t('hour')}}</p>
              </div>
              
              <div class="ccr-2 minut">
                <div class="ccr-2-select">
                  <v-select :searchable="false" :options="minutes" v-model="starttime.min" style="background-color: white" class="selectpicker show-tick"></v-select>
                </div>
                <p>{{$t('minute')}}</p>
              </div>

              <div class="separ"></div>

              <div class="ccr-1">
                <p>{{$t('till')}}</p>
                <div class="ccr-1-calendar">
                  <!-- || start calendar -->
                  <date-picker v-model="$store.state.enddate" valueType="format"></date-picker>
                  <!-- // stop calendar -->
                </div>
              </div>

              <div class="ccr-2 chasov">
                <div class="ccr-2-select">
                  <v-select :options="hours" :searchable="false" v-model="starttime.hour" style="background-color: white" class="selectpicker show-tick"></v-select>
                </div>
                <p>{{$t('hour')}}</p>
              </div>
              
              <div class="ccr-2 minut">
                <div class="ccr-2-select">
                  <v-select :searchable="false" :options="minutes" v-model="starttime.min" style="background-color: white" class="selectpicker show-tick"></v-select>
                </div>
                <p>{{$t('minute')}}</p>
              </div>

            </div>
            <!-- ccr stop -->
            
            <div class="outcome-2" @click="report()"><span>{{$t('outcom')}}</span></div>

        </div>
      </div>
      <!-- rp-form stop -->

    </form>
  </div>
  <!-- report-page header stop -->


  
  <!-- table-report-page start -->
  <div class="table-report-page">

    <table>
      <tr>
        <th>{{$t('income')}}</th>
        <th>{{$t('outcome')}}</th>
        <th>{{$t('return')}}</th>
      </tr>
      <tr>
        <td v-if="this.$store.state.usersreport">{{getData("Income")}}</td>
        <td v-if="this.$store.state.usersreport">{{getData("Outcome")}}</td>
        <td v-if="this.$store.state.usersreport">{{getData("Return")}}</td>
      </tr>
    </table>

    <table>
      <tr>
        <th>{{$t('jackpot')}}</th>
        <th>{{$t('unpay')}}</th>
        <th>{{$t('payedtotal')}}</th>
      </tr>
      <tr>
        <td v-if="this.$store.state.usersreport">{{getData("Jackpot")}}</td>
        <td v-if="this.$store.state.usersreport">{{getData("Unpay")}}</td>
        <td v-if="this.$store.state.usersreport">{{getData("Payed")}}</td>
      </tr>
    </table>

  </div>
  <!-- table-report-page stop -->
</div>
</template>

<script>
import i18n from '@/i18n'
import stats from '@/components/StatsReport.vue'

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import vSelect from 'vue-select';

import Vue from 'vue'
Vue.component('v-select', vSelect);
import "vue-select/dist/vue-select.css";

export default {
  name: 'Statistics',
  data: ()=>{
    return{
      starttime: {hour: '00', min: '00'},
      endtime: {hour: '23', min: '59'},
      hours: ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"],
      minutes: ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23",
       "24", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47",
       "48", "49", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59"],
    }
  },
  created() {
    this.$store.state.startdate = new Date().toLocaleDateString('en-CA');
    this.$store.state.enddate = new Date().toLocaleDateString('en-CA');
    this.$store.state.usersreport = null;
  },
  components: {
    DatePicker, stats
  },
  methods: {
    exit(){
      this.$store.state.usersreport = null;
      this.$store.state.startdate = new Date().toLocaleDateString('en-CA');
      this.$store.state.enddate = new Date().toLocaleDateString('en-CA');
      return this.$router.push({name: 'MainTab'})
    },
    report(){
      let start = this.$store.state.startdate + " " + this.starttime.hour + ":" + this.starttime.min + ":01";
      let end = this.$store.state.enddate + " " + this.endtime.hour + ":" + this.endtime.min + ":01";
      this.$store.dispatch('report', {token: this.$store.state.user.token, name: "users/report", start: start, end: end})
    },
    getData(name){
      let result = 0;
      if(name === "Income"){
        for(let i = 0; i < this.$store.state.usersreport.tickets.length; i++){
          result += this.$store.state.usersreport.tickets[i].Bets.map(item => item.Amount).reduce((prev, next) => prev + next);
        }
        return result.toFixed(2)
      }
      if(name === "Outcome"){
        for(let i = 0; i < this.$store.state.usersreport.tickets.length; i++){
          if(this.$store.state.usersreport.tickets[i].State == "Payed"){
            if(this.$store.state.usersreport.tickets[i].Type == "Single"){
              result += this.$store.state.usersreport.tickets[i].Bets.map(item => item.Winnings).reduce((prev, next) => prev + next);
            }else{
              if(this.$store.state.usersreport.tickets[i].Type == "Express"){
                result += this.$store.state.usersreport.tickets[i].Amount * this.$store.state.usersreport.tickets[i].Bets.map(item => item.Coefficient).reduce((prev, next) => prev * next);
              }
            }
          }
        }
        return result.toFixed(2)
      }
      if(name === "Return"){
        for(let i = 0; i < this.$store.state.usersreport.tickets.length; i++){
          if(this.$store.state.usersreport.tickets[i].State == "Return"){
            result += this.$store.state.usersreport.tickets[i].Amount;
          }
        }
        return result.toFixed(2)
      }
      if(name === "Unpay"){
        for(let i = 0; i < this.$store.state.usersreport.tickets.length; i++){
          if(this.$store.state.usersreport.tickets[i].State == "Won"){
            if(this.$store.state.usersreport.tickets[i].Type == "Single"){
              result += this.$store.state.usersreport.tickets[i].Bets.map(item => item.Winnings).reduce((prev, next) => prev + next);
            }else{
              result += this.$store.state.usersreport.tickets[i].Amount * this.$store.state.usersreport.tickets[i].Bets.map(item => item.Coefficient).reduce((prev, next) => prev * next);
            }
          }
        }
        return result.toFixed(2)
      }
      if(name === "Payed"){
        for(let i = 0; i < this.$store.state.usersreport.tickets.length; i++){
          if(this.$store.state.usersreport.tickets[i].State == "Payed"){
            if(this.$store.state.usersreport.tickets[i].Type == "Single"){
              result += this.$store.state.usersreport.tickets[i].Bets.map(item => item.Winnings).reduce((prev, next) => prev + next);
            }else{
              if(this.$store.state.usersreport.tickets[i].Type == "Express"){
                result += this.$store.state.usersreport.tickets[i].Amount * this.$store.state.usersreport.tickets[i].Bets.map(item => item.Coefficient).reduce((prev, next) => prev * next);
              }
            }
          }
        }
        return result.toFixed(2)
      }
      if(name == "Jackpot"){
         for(let i = 0; i < this.$store.state.usersreport.tickets.length; i++){
          if(this.$store.state.usersreport.tickets[i].State == "Payed"){
            for(let x = 0; x < this.$store.state.usersreport.tickets[i].Bets.length; x++){
              if(this.$store.state.usersreport.tickets[i].Bets[x].Jackpot == "Yes"){
                result += this.$store.state.usersreport.tickets[i].Bets[x].JackpotAmount;
              }
            }
          }
        }
        return result.toFixed(2)
      }
    }
  }
};
</script>

